/* eslint-disable */
import React from 'react';
import HeroBanner from './components/HeroBanner';
import QuickLinks from './components/QuickLinks';
import NewsSection from './components/NewsSection';
import './styles/Home.css';

const Home = ({ currentPage, setCurrentPage }) => {
  return (
    <div className="home-page" id='home-page'>
      <HeroBanner/>
      <QuickLinks currentPage={currentPage} setCurrentPage={setCurrentPage}/>
      <NewsSection currentPage={currentPage} setCurrentPage={setCurrentPage} />
      
      <section className="statistics-section">
        <div className="container">
          <h2 className="section-title">Our Impact in Numbers</h2>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">50+</div>
              <div className="stat-label">Rapid Response Teams</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">100+</div>
              <div className="stat-label">Training Programs</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">25+</div>
              <div className="stat-label">Active Partnerships</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">15+</div>
              <div className="stat-label">Disease Outbreaks Managed</div>
            </div>
          </div>
        </div>
      </section>

      <section className="emergency-section">
        <div className="container">
          <div className="emergency-alert-banner">
            <div className="alert-content">
              <h3>Public Health Emergency Alert</h3>
              <p>Latest updates on disease outbreaks and preventive measures</p>
            </div>
            <button className="alert-button">View Alerts</button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;